module.exports = __webpack_public_path__ + "img/BG831447150.8e1ab248.png";